import Vue from 'vue'
import Router from 'vue-router'

// 引用模板

const shop = r => require.ensure([], () => r(require('../page/shop/shop.vue')), 'shop');
const search = r => require.ensure([], () => r(require('../page/shop/search.vue')), 'search');
const productList = r => require.ensure([], () => r(require('../page/shop/productList.vue')), 'productList');
const skillList = r => require.ensure([], () => r(require('../page/shop/skillList.vue')), 'skillList');
const tjList = r => require.ensure([], () => r(require('../page/shop/tjList.vue')), 'tjList');
const tgList = r => require.ensure([], () => r(require('../page/shop/tgList.vue')), 'tgList');
const productDetail = r => require.ensure([], () => r(require('../page/shop/productDetail.vue')), 'productDetail');
const shopCart = r => require.ensure([], () => r(require('../page/shop/shopCart.vue')), 'shopCart'); //购物车
const noProduct = r => require.ensure([], () => r(require('../components/noProduct.vue')), 'noProduct'); //该商品已下架

const confirmPay = r => require.ensure([], () => r(require('../page/shop/confirmPay.vue')), 'confirmPay'); //确认订单
const payResult = r => require.ensure([], () => r(require('../page/shop/payResult.vue')), 'payResult'); //确认订单

//订单 
const category = r => require.ensure([], () => r(require('../page/category/category.vue')), 'category');
const scene = r => require.ensure([], () => r(require('../page/scene/scene.vue')), 'scene');
const newDetail = r => require.ensure([], () => r(require('../page/scene/newDetail.vue')), 'newDetail');
const companyFreeTry = r => require.ensure([], () => r(require('../page/freeTry/companyFreeTry.vue')), 'companyFreeTry');
const freeTryList = r => require.ensure([], () => r(require('../page/freeTry/freeTryList.vue')), 'freeTryList');

//个人中心
const userIndex = r => require.ensure([], () => r(require('../page/user/userIndex.vue')), 'userIndex');
const registerMember = r => require.ensure([], () => r(require('../page/user/registerMember.vue')), 'registerMember');
const invitation = r => require.ensure([], () => r(require('../page/user/invitation.vue')), 'invitation'); //有奖邀请
const invitationPacket = r => require.ensure([], () => r(require('../page/user/invitationPacket.vue')), 'invitationPacket'); //百元新人礼包
const getPacketFail = r => require.ensure([], () => r(require('../page/user/getPacketFail.vue')), 'getPacketFail'); //领取失败
const wallet = r => require.ensure([], () => r(require('../page/user/wallet.vue')), 'wallet'); //钱包
const editPersonal = r => require.ensure([], () => r(require('../page/user/editPersonal.vue')), 'editPersonal'); //修改个人信息(未开通)


//优惠券
const coupon = r => require.ensure([], () => r(require('../page/user/coupon.vue')), 'coupon'); //我的优惠券

const bill = r => require.ensure([], () => r(require('../page/user/bill.vue')), 'bill');
const address = r => require.ensure([], () => r(require('../page/user/address.vue')), 'address');
const addAddress = r => require.ensure([], () => r(require('../page/user/addAddress.vue')), 'addAddress');
const chooseAddress = r => require.ensure([], () => r(require('../page/user/chooseAddress.vue')), 'chooseAddress');

//自助机优惠券
const machineCoupon = r => require.ensure([], () => r(require('../page/user/machineCoupon.vue')), 'machineCoupon'); //自助机优惠券

//门店列表
const storeList = r => require.ensure([], () => r(require('../page/store/storeList.vue')), 'storeList');

//订单 
const order = r => require.ensure([], () => r(require('../page/order/order.vue')), 'order');
const orderDetail = r => require.ensure([], () => r(require('../page/order/orderDetail.vue')), 'orderDetail');
const refund = r => require.ensure([], () => r(require('../page/order/refund.vue')), 'refund');
const refundList = r => require.ensure([], () => r(require('../page/order/refundList.vue')), 'refundList');
const refundDetail = r => require.ensure([], () => r(require('../page/order/refundDetail.vue')), 'refundDetail');
const deliver = r => require.ensure([], () => r(require('../page/deliver/deliver.vue')), 'deliver');
const deliverDetail = r => require.ensure([], () => r(require('../page/deliver/deliverDetail.vue')), 'deliverDetail');
const deliverList = r => require.ensure([], () => r(require('../page/deliver/deliverList.vue')), 'deliverList');
const deliverOneDetail = r => require.ensure([], () => r(require('../page/deliver/deliverOneDetail.vue')), 'deliverOneDetail');
//本月特惠
const monthSpecial = r => require.ensure([], () => r(require('../page/special/monthSpecial.vue')), 'monthSpecial');

// 配置路由
export default [{
		path: '/',
		redirect: '/shop'
	},
	{
		path: '*',
		component: shop,
	},
	{
		path: '/noProduct',
		component: noProduct,
	},
	{
		path: '/store',
		component: storeList
	},
	{
		path: '/shop',
		component: shop,
	},
	{
		path: '/search',
		component: search
	},
	{
		path: '/skillList',
		component: skillList
	},
	{
		path: '/productList',
		component: productList,
		meta: {
			keepAlive: true
		}
	},
	{
		path: '/tjList',
		component: tjList,
	},
	{
		path: '/tgList',
		component: tgList,
	},
	{
		path: '/productDetail',
		component: productDetail,

	}, {
		path: '/shopCart',
		component: shopCart,

	},
	{
		path: '/category',
		component: category
	},
	{
		path: '/scene',
		component: scene,

	},
	{
		path: '/freeTry',
		component: companyFreeTry
	},
	{
		path: '/user',
		component: userIndex
	},


	{
		path: '/register',
		component: registerMember,
	},
	
	{
		path: '/bill',
		component: bill,
	},
	{
		path: '/address',
		component: address,
	}, {
		path: '/addAddress',
		component: addAddress,
	}, {
		path: '/chooseAddress',
		component: chooseAddress,
	}, {
		path: '/confirmPay',
		component: confirmPay,
	}, {
		path: '/payResult',
		component: payResult,
	}, {
		path: '/order',
		component: order,
	}, {
		path: '/orderDetail',
		component: orderDetail,
	}, {
		path: '/refund',
		component: refund,
	}, {
		path: '/refundList',
		component: refundList,
	}, {
		path: '/refundDetail',
		component: refundDetail,
	}, {
		path: '/deliver',
		component: deliver,
		name: 'deliver',
		children: [{
				path: '/',
				redirect: '/deliverList'
			},
			{
				path: '/deliverDetail',
				component: deliverDetail,
			}, {
				path: '/deliverList',
				component: deliverList,
			}, {
				path: '/deliverOneDetail',
				component: deliverOneDetail,
			}
		]
	}, {
		path: '/coupon',
		component: coupon,
	}, {
		path: '/invitation',
		component: invitation,
	}, {
		path: '/getPacketFail',
		component: getPacketFail,
	}, {
		path: '/invitationPacket',
		component: invitationPacket,
	}, {
		path: '/newDetail',
		component: newDetail,
	}, {
		path: '/freeTryList',
		component: freeTryList,
	}, {
		path: '/wallet',
		component: wallet,
	}, {
		path: '/editPersonal',
		component: editPersonal,
	}, {
		path: '/monthSpecial',
		component: monthSpecial,
	}, {
		path: '/machineCoupon',
		component: machineCoupon,
	}
	
	
]



// WEBPACK FOOTER //
// ./src/router/index.js